import m from 'mithril';
import Icon from '../icon/icon';

const message = ({
  className,
  icon,
  iconClasses = ['fa-fw', 'fa-2x', 'mr2'],
  message,
}: {
  className?: string;
  icon?: string;
  iconClasses?: string[];
  message?: string;
  // TODO: check if `= {}` is needed. Is somebody calling message without any arguments?
} = {}) =>
  m(
    '.message',
    {
      className,
    },
    [m('.message-body', [m('.flex.flex-cols', [m(Icon, { name: icon, classes: iconClasses }), message])])],
  );

export default message;
